// extracted by mini-css-extract-plugin
export default {"cls1":"VeloResponsiveText-Mobile_cls1__qqi91","cls2":"VeloResponsiveText-Mobile_cls2__0QynA VeloResponsiveText-Mobile_cls1__qqi91"};